import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useSolarCalc } from "../../../../util/calculations";
import { convertPercentage } from "../../../../util/targetCalc";

const TargetUnusedSection = (props) => {
	const convPer = convertPercentage;
	const register = props.register;
	const isEditMode = props.isEditMode;
	const setValue = props.setValue;
	const watch = props.watch;
	const data = props.data;

	const calc = useSolarCalc();
	const [isSameValue, setIsSameValue] = useState(false);
	const [singleValue, setSingleValue] = useState(0);

	const january = watch("january_unused", convPer(data.january_unused));
	const february = watch("february_unused", convPer(data.february_unused));
	const march = watch("march_unused", convPer(data.march_unused));
	const april = watch("april_unused", convPer(data.april_unused));
	const may = watch("may_unused", convPer(data.may_unused));
	const june = watch("june_unused", convPer(data.june_unused));
	const july = watch("july_unused", convPer(data.july_unused));
	const august = watch("august_unused", convPer(data.august_unused));
	const september = watch("september_unused", convPer(data.september_unused));
	const october = watch("october_unused", convPer(data.october_unused));
	const november = watch("november_unused", convPer(data.november_unused));
	const december = watch("december_unused", convPer(data.december_unused));

	const [errors, setErrors] = useState({});

	const readOnlyStyle = { color: "#c7c7c7" };

	/**
	 * Handle input change for single same value
	 * @param {event} evt
	 * @returns
	 */
	const handleSingle = (evt) => {
		const singleValue = evt.target.value;
		setSingleValue(singleValue);
		setSameValueForAll(singleValue);
	};

	/**
	 * Handle checkbox change
	 * @param {event} evt
	 * @returns
	 */
	const handleCheck = (evt) => {
		setIsSameValue(evt.target.checked);
		setSameValueForAll(singleValue);
	};

	/**
	 * Handle input change
	 * @param {event} evt
	 * @returns
	 */
	const handleIndividualValues = (evt) => {
		const individualValues = evt.target.value;
		// setFunc(individualValues);
	};

	/**
	 * Set same value for all inputs
	 * @param {number} singleValue
	 * @returns
	 */
	const setSameValueForAll = (singleValue) => {
		setValue("january_unused", singleValue);
		setValue("february_unused", singleValue);
		setValue("march_unused", singleValue);
		setValue("april_unused", singleValue);
		setValue("may_unused", singleValue);
		setValue("june_unused", singleValue);
		setValue("july_unused", singleValue);
		setValue("august_unused", singleValue);
		setValue("september_unused", singleValue);
		setValue("october_unused", singleValue);
		setValue("november_unused", singleValue);
		setValue("december_unused", singleValue);
	};

	/**
	 * Check if all unused values are the same
	 * @param {obj} data
	 * @returns boolean
	 */
	const checkSameValue = (data) => {
		const entries = Object.entries(data);
		const unusedValues = entries.map((entry) => {
			if (entry[0].includes("unused")) return entry[1];
			else return "";
		});

		const filteredUnused = unusedValues.filter((value) => value !== "");
		const hasSameValues = filteredUnused.every((v) => v === filteredUnused[0]);

		return hasSameValues;
	};

	/**
	 * Calculate average unused
	 * @param {array} data
	 * @returns average unused
	 */
	const calculateAvg = (data) => {
		const avgUnused = data.reduce((a, b) => parseFloat(a) + parseFloat(b)) / 12;

		return calc.parseFormatNumber(avgUnused, 3);
	};

	/**
	 * Reset to initial state
	 */
	const resetSection = () => {
		setSingleValue(0);
		setSameValueForAll(0);
		setIsSameValue(false);
	};

	useEffect(() => {
		if (data != null) {
			const dataEntries = Object.entries(data);
			const unusedEntries = dataEntries.filter((entry) =>
				entry[0].includes("_unused")
			);

			const unusedData = Object.fromEntries(unusedEntries);
			const hasSameUnusedvalue = checkSameValue(unusedData);

			// Init form with same values settings
			setIsSameValue(hasSameUnusedvalue);
			if (hasSameUnusedvalue) setSingleValue(convPer(data.january_unused));
		}

		return () => resetSection();
	}, [props.data]);

	useEffect(() => {
		const monthlyUnused = [
			january,
			february,
			march,
			april,
			may,
			june,
			july,
			august,
			september,
			october,
			november,
			december,
		];

		const avgUnused = calculateAvg(monthlyUnused);
		const hasSameUnusedvalue = monthlyUnused.every(
			(month) => month == monthlyUnused[0]
		);

		// Init form with same values settings
		setIsSameValue(hasSameUnusedvalue);
		if (hasSameUnusedvalue) setSingleValue(monthlyUnused[0]);

		props.setAvgUnused(avgUnused);
	}, [
		january,
		february,
		march,
		april,
		may,
		june,
		july,
		august,
		september,
		october,
		november,
		december,
	]);

	useEffect(() => {
		const errorEntries = Object.entries(props.errors);
		const unusedErrorEntries = errorEntries.map((entry) => {
			if (entry[0].includes("unused")) return entry;
			else return "";
		});

		const filteredUnused = unusedErrorEntries.filter((entry) => entry !== "");

		setErrors(filteredUnused);
	}, [props.errors]);

	return (
		<>
			<hr />
			<Row>
				<Col md="2">
					<h5>Unused (%)</h5>
					{errors.length > 0 && (
						<span className="required">*All Unused(%) fields required</span>
					)}
				</Col>
				<Col md="4">
					<input
						type="number"
						step="0.01"
						name="single_unused"
						disabled={!isSameValue}
						readOnly={!isEditMode}
						defaultValue={singleValue}
						onChange={(evt) => handleSingle(evt)}
					></input>
				</Col>
				<Col md="6">
					<Row>
						<Col md="6">
							<label>Same values for all months</label>
						</Col>
						<Col md="1">
							<input
								type="checkbox"
								onChange={(evt) => (isEditMode ? handleCheck(evt) : false)}
								checked={isSameValue}
							></input>
						</Col>
					</Row>
				</Col>
			</Row>
			<hr />
			<Row>
				<Col md="4">
					<Row>
						<Col md="3">
							<label>January</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								ref={register}
								name="january_unused"
								readOnly={isSameValue || (!isSameValue && !isEditMode)}
								style={isSameValue ? readOnlyStyle : {}}
								defaultValue={january}
								onChange={(evt) => handleIndividualValues(evt)}
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>February</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								ref={register}
								name="february_unused"
								readOnly={isSameValue || (!isSameValue && !isEditMode)}
								style={isSameValue ? readOnlyStyle : {}}
								defaultValue={february}
								onChange={(evt) => handleIndividualValues(evt)}
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>March</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								ref={register}
								name="march_unused"
								readOnly={isSameValue || (!isSameValue && !isEditMode)}
								style={isSameValue ? readOnlyStyle : {}}
								defaultValue={march}
								onChange={(evt) => handleIndividualValues(evt)}
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>April</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								ref={register}
								name="april_unused"
								readOnly={isSameValue || (!isSameValue && !isEditMode)}
								style={isSameValue ? readOnlyStyle : {}}
								defaultValue={april}
								onChange={(evt) => handleIndividualValues(evt)}
							></input>
						</Col>
					</Row>
				</Col>
				<Col md="4">
					<Row>
						<Col md="3">
							<label>May</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								ref={register}
								name="may_unused"
								readOnly={isSameValue || (!isSameValue && !isEditMode)}
								style={isSameValue ? readOnlyStyle : {}}
								defaultValue={may}
								onChange={(evt) => handleIndividualValues(evt)}
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>June</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								ref={register}
								name="june_unused"
								readOnly={isSameValue || (!isSameValue && !isEditMode)}
								style={isSameValue ? readOnlyStyle : {}}
								defaultValue={june}
								onChange={(evt) => handleIndividualValues(evt)}
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>July</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								ref={register}
								name="july_unused"
								readOnly={isSameValue || (!isSameValue && !isEditMode)}
								style={isSameValue ? readOnlyStyle : {}}
								defaultValue={july}
								onChange={(evt) => handleIndividualValues(evt)}
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>August</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								ref={register}
								name="august_unused"
								readOnly={isSameValue || (!isSameValue && !isEditMode)}
								style={isSameValue ? readOnlyStyle : {}}
								defaultValue={august}
								onChange={(evt) => handleIndividualValues(evt)}
							></input>
						</Col>
					</Row>
				</Col>
				<Col md="4">
					<Row>
						<Col md="3">
							<label>September</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								ref={register}
								name="september_unused"
								readOnly={isSameValue || (!isSameValue && !isEditMode)}
								style={isSameValue ? readOnlyStyle : {}}
								defaultValue={september}
								onChange={(evt) => handleIndividualValues(evt)}
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>October</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								ref={register}
								name="october_unused"
								readOnly={isSameValue || (!isSameValue && !isEditMode)}
								style={isSameValue ? readOnlyStyle : {}}
								defaultValue={october}
								onChange={(evt) => handleIndividualValues(evt)}
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>November</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								ref={register}
								name="november_unused"
								readOnly={isSameValue || (!isSameValue && !isEditMode)}
								style={isSameValue ? readOnlyStyle : {}}
								defaultValue={november}
								onChange={(evt) => handleIndividualValues(evt)}
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>December</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								ref={register}
								name="december_unused"
								readOnly={isSameValue || (!isSameValue && !isEditMode)}
								style={isSameValue ? readOnlyStyle : {}}
								defaultValue={december}
								onChange={(evt) => handleIndividualValues(evt)}
							></input>
						</Col>
					</Row>
				</Col>
			</Row>
		</>
	);
};

export default TargetUnusedSection;
